import $ from 'jquery';

function states_and_niche_markets() {
  
  // highlight the first item
  $('#videos .related-item').first().addClass('highlight');
  $('#maps_and_data .related-item').first().addClass('highlight');
  
  // change the item on click
  $('.related-item').click(function() {
    changeRelated(this);
    return false;
  });
  
  // switch fuel price box from data to chart
  $('div.prices-chart').click(function() {
    $('div.fuel-prices-data').hide();
    $('div.fuel-prices-chart').show();
    $('div.prices-on').removeClass('prices-on').addClass('prices-off');
    $(this).removeClass('prices-off').addClass('prices-on');
  });
  
  // switch fuel price box from chart to data
  $('div.prices-data').click(function() {
    $('div.fuel-prices-chart').hide();
    $('div.fuel-prices-data').show();
    $('div.prices-on').removeClass('prices-on').addClass('prices-off');
    $(this).removeClass('prices-off').addClass('prices-on');
  });
  
  // fix for a Safari bug that breaks scrolling divs
  // when using the back and forward browser buttons
  $(window).on("popstate", function() {
    $(".states-niche-box, .related-items, .webstories, ul.laws").toggleClass("div-scroll-fix");
  });
}

function changeRelated(item) {
  var relatedType = $(item).data("related-type");

  // switch the highlight
  $('#' + relatedType + ' .highlight').removeClass('highlight');
  $(item).addClass('highlight');

  // switch the iframe
  var url = $(item).find('.related-url').text();
  $('iframe.' + relatedType).attr('src', '').attr('src', url);

  if (relatedType == 'videos') {
    // switch the text version
    var text = $(item).parent().attr('href') + '?text';
    $('#videos .text-version a').attr('href', '').attr('href', text);
  }
}

function carouselVehicles() {
  $.fn.reverse = [].reverse;

  $("#carousel-next").click(function() {
    $("div.vehicle").slice(0, 6).each(function() {
      $(this).removeClass("show").addClass("hide");
      $("#vehicles-list").append(this);
    });
    $("div.vehicle").slice(0, 6).each(function() {
      $(this).removeClass("hide").addClass("show");
    });
  });

  $("#carousel-prev").click(function() {
    $("div.vehicle").slice(0, 6).each(function() {
      $(this).removeClass("show").addClass("hide");
    });
    $("div.vehicle").slice(-6).reverse().each(function() {
      $(this).removeClass("hide").addClass("show");
      $("#vehicles-list").prepend(this);
    });
  });
}

$(function() {
  states_and_niche_markets();
  carouselVehicles();
});
